import React, { useCallback, useEffect, useState } from 'react'
import { Button, Checkbox, Divider, FormControlLabel, Grid, Paper, TextField, Typography } from '@material-ui/core'
import { useParams } from 'react-router'
import { useVestigioService } from 'hooks/useVestigioService'
import { useCadaverService } from 'hooks/useCadaverService'
import { usePericiandoService } from 'hooks/usePericiandoService'
import { useVeiculoService } from 'hooks/useVeiculoService'
import { useTipoExameService } from 'hooks/useTipoExameService'
import { useVagaService } from 'hooks/useVagaService'
import { useLocal } from 'hooks/useLocal'
import { useExameSolicitadoService } from 'hooks/useExameSolicitadoService'
import useRouter from 'utils/useRouter'
import useStyles from './styles'
import { getVestigioRestricoes } from 'utils/helpers'
import { Autocomplete } from '@material-ui/lab'
import { getLabelEndereco } from 'helpers/labels'
import { v4 } from 'uuid'
import { FormDNA } from '../../FormDNA'
import tiposDeExame from 'globals/tiposDeExame'
import { FormToxicologia } from '../../FormToxicologia'
import { FormBiologia } from '../../FormBiologia'
import { ModalConfirmacao, SecaoGenerica, CustomButton } from 'components'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SaveIcon from '@material-ui/icons/Save'

/**
 *
 * route.origem === 'REQUISICAO': cadastro da solicitação pela guia de requisição
 * route.origem === 'SOLICITACAO': cadastro da solicitação pelo caso
 * route.origem === 'CONFIRMACAO': confirmação de exame solicitado pendente de confirmação
 * route.origem === 'EDICAO': edição de exame solicitado confirmado
 * route.origem === 'ADICAO': adição de exame em solicitação de exame já existente
 */
export const FormAdicionarExame = (props) => {
  const { aberto, setExamesSolicitados, idCaso, exameSolicitado, setOpen, editar, route } = props
  const classes = useStyles()
  const params = useParams()
  const router = useRouter()
  const vestigioService = useVestigioService()
  const cadaverService = useCadaverService()
  const periciandoService = usePericiandoService()
  const veiculoService = useVeiculoService()
  const tipoExameService = useTipoExameService()
  const localService = useLocal()
  const vagaService = useVagaService()
  const exameSolicitadoService = useExameSolicitadoService()
  const [processandoExameSolicitado, setProcessandoExameSolicitado] = useState(false)
  const [tiposExames, setTiposExames] = useState(null)
  const [processandoTiposExames, setProcessandoTiposExames] = useState(false)
  const [vagasDisponiveis, setVagasDisponiveis] = useState([])
  const [processandoVagasDisponiveis, setProcessandoVagasDisponiveis] = useState(false)
  const [listaVestigios, setListaVestigios] = useState([])
  const [processandoListaVestigios, setProcessandoListaVestigios] = useState(false)
  const [listaPericiandos, setListaPericiandos] = useState([])
  const [processandoListaPericiandos, setProcessandoListaPericiandos] = useState(false)
  const [listaVeiculos, setListaVeiculos] = useState([])
  const [processandoListaVeiculos, setProcessandoListaVeiculos] = useState(false)
  const [listaCadaveres, setListaCadaveres] = useState([])
  const [processandoListaCadaveres, setProcessandoListaCadaveres] = useState(false)
  const [listaLocais, setListaLocais] = useState([])
  const [processandoListaLocais, setProcessandoListaLocais] = useState(false)
  const [processandoTiposProcedimentos, setProcessandoTiposProcedimentos] = useState(false)
  const [listaVitima, setListaVitima] = useState([])
  const [form, setForm] = useState({
    setor: null,
    tipoEx: null,
    listaObjetosExaminados: [],
    listaQuesitos: [],
    novoQuesito: '',
    listaOpcoesSetoresResponsaveis: [],
    vagasDisponiveis: [],
    tipoCaso: null,
    outroTipoCaso: '',
    substanciaEnvolvida: '',
    suspeitaIntoxicacao: 'NÃO INFORMADO',
    justificativaSolicitacao: '',
    exameToxicologicoEssencial: 'NÃO INFORMADO',
    recebeuSocorro: 'NÃO INFORMADO',
    tempoSocorro: '',
    recebeuMedicamento: 'NÃO INFORMADO',
    medicamentos: '',
    dataObito: null,
    dataColeta: null,
    horaColeta: '',
    pendenteConfirmacao: false,

    /* form Biologia */
    isVitimaDesconhecida: false,
    vitima: null,
    exameSexologico: null,
    dataFato: null,
    horaFato: null,
    concursoPessoas: null,
    conjuncaoCarnal: [],
    usoPreservativo: null,
    atosLibidinosos: [],
    realizouHigiene: null,
    coletadoEmLocal: null,
    usoLuminol: null,
    coletadoDiretamente: null,
    outraObservacoes: null,
  })
  const [formErro, setFormErro] = useState(false)
  const [listaObjetosDoCaso, setListaObjetosDoCaso] = useState([])
  const [processandoOperacao, setProcessandoOperacao] = useState(false)

  const fetchTiposExames = useCallback(async () => {
    const response = await tipoExameService.listarTiposExamesAsync(setProcessandoTiposExames)
    setTiposExames(response)
  }, [])

  const fetchVagasDisponiveis = useCallback(async () => {
    const response = await vagaService.listarVagasDisponiveisAsync(setProcessandoVagasDisponiveis)
    setVagasDisponiveis(response)
  }, [idCaso])

  const fetchVestigiosDeCaso = useCallback(async () => {
    if (idCaso) {
      const response = await vestigioService.listarVestigiosDeCasoAsync(idCaso, setProcessandoListaVestigios)
      setListaVestigios(response)
    }
  }, [idCaso])

  const fetchCadaveresDeCaso = useCallback(async () => {
    if (idCaso) {
      const response = await cadaverService.listarCadaveresDeCasoAsync(idCaso, setProcessandoListaCadaveres)
      setListaVitima((listaVitima) => [...listaVitima, ...response])
      setListaCadaveres(response)
    }
  }, [idCaso])

  const fetchPericiandosDeCaso = useCallback(async () => {
    if (idCaso) {
      const response = await periciandoService.listarPericiandosDeCasoAsync(idCaso, setProcessandoListaPericiandos)
      setListaVitima((listaVitima) => [...listaVitima, ...response])
      setListaPericiandos(response)
    }
  }, [idCaso])

  const fetchVeiculosDeCaso = useCallback(async () => {
    if (idCaso) {
      const response = await veiculoService.listarVeiculosDeCasoAsync(idCaso, setProcessandoListaVeiculos)
      setListaVeiculos(response)
    }
  }, [idCaso])

  const fetchLocaisDeCaso = useCallback(async () => {
    if (idCaso) {
      const response = await localService.listarLocaisDeCasoAsync(idCaso, setProcessandoListaLocais)
      setListaLocais(response)
    }
  }, [idCaso])

  const filtrarVagasPorTipoExame = useCallback(
    (idTipoExame) => {
      const result = []

      if (idTipoExame && vagasDisponiveis) {
        vagasDisponiveis.forEach((vaga) => {
          if (vaga.id_tipo_exame === idTipoExame) {
            result.push(vaga)
          }
        })
      }
      return result
    },

    [vagasDisponiveis]
  )

  const verificarObjetoEmTipoExame = useCallback((objeto, tipoExame) => {
    if (tipoExame.objetosPericia && tipoExame.objetosPericia.includes(objeto)) {
      return true
    }
    return false
  }, [])

  const getListaObjetosDoCasoPorExame = useCallback(
    (tipoExame) => {
      let listaObjetos = []

      if (verificarObjetoEmTipoExame('VEICULO', tipoExame)) {
        listaObjetos = listaObjetos.concat(
          listaVeiculos.map((veiculo) => {
            veiculo.flag = 'VEICULO'
            return veiculo
          })
        )
      }
      if (verificarObjetoEmTipoExame('VESTIGIO', tipoExame)) {
        if (listaVestigios?.length) {
          listaObjetos = listaObjetos.concat(
            getVestigioRestricoes(listaVestigios, tipoExame).map((vestigio) => {
              vestigio.flag = 'VESTIGIO'
              return vestigio
            })
          )
        }
      }
      if (verificarObjetoEmTipoExame('CADAVER', tipoExame)) {
        listaObjetos = listaObjetos.concat(
          listaCadaveres.map((cadaver) => {
            cadaver.flag = 'CADAVER'
            return cadaver
          })
        )
      }
      if (verificarObjetoEmTipoExame('PERICIANDO', tipoExame)) {
        listaObjetos = listaObjetos.concat(
          listaPericiandos.map((periciando) => {
            periciando.flag = 'PERICIANDO'
            return periciando
          })
        )
      }
      if (verificarObjetoEmTipoExame('LOCAL', tipoExame)) {
        listaObjetos = listaObjetos.concat(
          listaLocais.map((local) => {
            local.flag = 'LOCAL'
            return local
          })
        )
      }

      return listaObjetos
    },
    [listaVeiculos, listaVestigios, listaCadaveres, listaPericiandos, listaLocais, verificarObjetoEmTipoExame]
  )

  const handleChange = (prop, value) => {
    setForm((prevState) => ({
      ...prevState,
      [prop]: value,
    }))
  }

  const handleChangeTipoExame = useCallback(
    (newValue) => {
      if (newValue) {
        setListaObjetosDoCaso(getListaObjetosDoCasoPorExame(newValue))
      } else {
        setListaObjetosDoCaso([])
      }

      setForm((prevState) => ({
        ...prevState,
        setor: null,
        tipoEx: newValue,
        listaObjetosExaminados: [],
        listaQuesitos: [],
        novoQuesito: '',
        listaOpcoesSetoresResponsaveis: [],
        vagasDisponiveis: [],
        tipoCaso: null,
        outroTipoCaso: '',
        substanciaEnvolvida: '',
        suspeitaIntoxicacao: 'NÃO INFORMADO',
        justificativaSolicitacao: '',
        exameToxicologicoEssencial: 'NÃO INFORMADO',
        recebeuSocorro: 'NÃO INFORMADO',
        tempoSocorro: '',
        recebeuMedicamento: 'NÃO INFORMADO',
        medicamentos: '',
        dataObito: null,
        dataColeta: null,
        horaColeta: '',
        isVitimaDesconhecida: false,
        vitima: null,
        exameSexologico: null,
        dataFato: null,
        horaFato: null,
        concursoPessoas: null,
        conjuncaoCarnal: [],
        usoPreservativo: null,
        atosLibidinosos: [],
        realizouHigiene: null,
        coletadoEmLocal: null,
        usoLuminol: null,
        coletadoDiretamente: null,
        outraObservacoes: null,
      }))
    },
    [getListaObjetosDoCasoPorExame]
  )

  useEffect(() => {
    if (route.origem === 'REQUISICAO') {
      setForm((prevState) => ({
        ...prevState,
        pendenteConfirmacao: true,
      }))
    }
    if (route.origem === 'CONFIRMACAO') {
      setForm((prevState) => ({
        ...prevState,
        pendenteConfirmacao: false,
      }))
    }
  }, [route.origem])

  useEffect(() => {
    if (!tiposExames) {
      fetchTiposExames()
    }
  }, [fetchTiposExames, tiposExames])

  useEffect(() => {
    fetchVagasDisponiveis()
  }, [fetchVagasDisponiveis])

  useEffect(() => {
    fetchVestigiosDeCaso()
  }, [fetchVestigiosDeCaso])

  useEffect(() => {
    fetchCadaveresDeCaso()
  }, [fetchCadaveresDeCaso])

  useEffect(() => {
    fetchVeiculosDeCaso()
  }, [fetchVeiculosDeCaso])

  useEffect(() => {
    fetchPericiandosDeCaso()
  }, [fetchPericiandosDeCaso])

  useEffect(() => {
    fetchLocaisDeCaso()
  }, [fetchLocaisDeCaso])

  const resetForm = () => {
    setForm({
      setor: null,
      tipoEx: null,
      listaObjetosExaminados: [],
      listaQuesitos: [],
      novoQuesito: '',
      listaOpcoesSetoresResponsaveis: [],
      vagasDisponiveis: [],
      tipoCaso: null,
      outroTipoCaso: '',
      substanciaEnvolvida: '',
      suspeitaIntoxicacao: 'SIM',
      justificativaSolicitacao: '',
      exameToxicologicoEssencial: 'SIM',
      recebeuSocorro: 'NÃO INFORMADO',
      tempoSocorro: '',
      recebeuMedicamento: 'NÃO INFORMADO',
      medicamentos: '',
      dataObito: null,
      dataColeta: null,
      horaColeta: '',
      pendenteConfirmacao: false,
      isVitimaDesconhecida: false,
      vitima: null,
      exameSexologico: null,
      dataFato: null,
      horaFato: null,
      concursoPessoas: null,
      conjuncaoCarnal: [],
      usoPreservativo: null,
      atosLibidinosos: [],
      realizouHigiene: null,
      coletadoEmLocal: null,
      usoLuminol: null,
      coletadoDiretamente: null,
      outraObservacoes: null,
    })
    setProcessandoOperacao(false)
  }

  const montarDadosToxicologia = () => {
    return {
      tipoCaso: form.tipoCaso,
      outroTipoCaso: form.outroTipoCaso,
      vitima: form.vitima ? (form.vitima?.hasOwnProperty('cpf') ? form.vitima : null) : null,
      vitima_cadaver: form.vitima ? (form.vitima?.nic ? form.vitima : null) : null,
      substanciaEnvolvida: form.substanciaEnvolvida,
      suspeitaIntoxicacao: form.suspeitaIntoxicacao === 'SIM' ? true : false,
      justificativaSolicitacao: form.justificativaSolicitacao,
      exameToxicologicoEssencial: form.exameToxicologicoEssencial === 'SIM' ? true : false,
      recebeuSocorro: form.recebeuSocorro,
      tempoSocorro: form.tempoSocorro,
      recebeuMedicamento: form.recebeuMedicamento,
      medicamentos: form.medicamentos,
      dataObito: form.dataObito,
      dataColeta: form.dataColeta,
      horaColeta: form.horaColeta,
      descricaoCaso: form.descricaoCaso,
    }
  }

  const montarDadosBiologia = () => {
    return {
      vitima: form.vitima ? (form.vitima?.hasOwnProperty('cpf') ? form.vitima : null) : null,
      vitima_cadaver: form.vitima ? (form.vitima?.nic ? form.vitima : null) : null,
      dataColeta: form.dataColeta,
      horaColeta: form.horaColeta,
      exameSexologico: form.exameSexologico,
      dataFato: form.dataFato,
      horaFato: form.horaFato,
      concursoPessoas: form.concursoPessoas,
      conjuncaoCarnal: form.conjuncaoCarnal?.join(', '),
      usoPreservativo: form.usoPreservativo,
      atosLibidinosos: form.atosLibidinosos?.join(', '),
      realizouHigiene: form.realizouHigiene,
      coletadoEmLocal: form.coletadoEmLocal,
      usoLuminol: form.usoLuminol,
      coletadoDiretamente: form.coletadoDiretamente,
      outraObservacoes: form.outraObservacoes,
    }
  }

  const montarDadosDNA = () => {
    return {
      vitima: form.vitima ? (form.vitima?.hasOwnProperty('cpf') ? form.vitima : null) : null,
      vitima_cadaver: form.vitima ? (form.vitima?.nic ? form.vitima : null) : null,
      suspeito: form.suspeito,
      objetivoExame: form.objetivoExame,
      outroObjetivoExame: form.outroObjetivoExame,
      outraObservacoes: form.outraObservacoes,
    }
  }

  // utilizado no cadastro da solicitação de exame
  const confirmarExameEmSolicitacao = (dados) => {
    // ao editar o exame solicitado no processo de cadastro da solicitação de exame
    if (editar) {
      setExamesSolicitados((prevState) =>
        prevState.map((exame) => {
          if (exame.uuid === exameSolicitado.uuid) {
            return {
              ...dados,
              uuid: exame.uuid,
            }
          } else {
            return exame
          }
        })
      )
    } else {
      // ao adicionar exame solicitado no processo de cadastro da solicitação de exame
      setExamesSolicitados((prevState) => [
        ...prevState,
        {
          ...dados,
          uuid: v4(),
        },
      ])
    }
    setOpen(false)
  }

  // utilizado em:
  //  edição de um exame solicitado existente;
  //  confirmação de exame pendente de confirmação;
  //  adição de exame solicitado em solicitação de exame existente
  const confirmarExame = async (dados) => {
    // montar dados agendamento

    if (route.origem === 'EDICAO') {
      await exameSolicitadoService.editarExameSolicitado(exameSolicitado.id, dados, 'EDICAO')
      router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${exameSolicitado.id}`)
    }

    if (route.origem === 'CONFIRMACAO') {
      await exameSolicitadoService.editarExameSolicitado(exameSolicitado.id, dados, 'CONFIRMACAO')
      router.history.push(`/solicitacaoexame/fichasolicitacaoexame/detalhar/${exameSolicitado.id_solicitacao_exame}`)
    }

    if (route.origem === 'ADICAO') {
      await exameSolicitadoService.cadastrarExameSolicitado(dados)
      router.history.push(`/solicitacaoexame/fichasolicitacaoexame/detalhar/${params.idSolicitacao}`)
    }

    setProcessandoOperacao(false)
  }

  const confirmar = async () => {
    try {
      setProcessandoOperacao(true)
      let dadosEspecificos = {}
      if (form.tipoEx?.cod === tiposDeExame.DNA) {
        dadosEspecificos = montarDadosDNA()
      }

      if (isExameToxicologico(form.tipoEx)) {
        dadosEspecificos = montarDadosToxicologia()
      }

      if (isExameBiologia(form.tipoEx)) {
        dadosEspecificos = montarDadosBiologia()
      }

      const dados = {
        ...dadosEspecificos,
        tipoEx: form.tipoEx,
        setor: form.setor,
        id_solicitacao_exame: route.origem === 'ADICAO' ? params.idSolicitacao : form.id_solicitacao_exame,
        pendenteConfirmacao: form.pendenteConfirmacao,
        cadavs: form.listaObjetosExaminados?.filter((obj) => obj.flag === 'CADAVER'),
        perics: form.listaObjetosExaminados?.filter((obj) => obj.flag === 'PERICIANDO'),
        locais: form.listaObjetosExaminados?.filter((obj) => obj.flag === 'LOCAL'),
        veiculos: form.listaObjetosExaminados?.filter((obj) => obj.flag === 'VEICULO'),
        vests: form.listaObjetosExaminados?.filter((obj) => obj.flag === 'VESTIGIO'),
        quesitos: form.tipoEx.quesitos?.map((quesito) => ({ quesito: quesito.quesito })),
      }

      if (route.origem === 'CONFIRMACAO' || route.origem === 'EDICAO' || route.origem === 'ADICAO') {
        await confirmarExame(dados)
      } else {
        confirmarExameEmSolicitacao(dados)
      }
      resetForm()
    } catch (error) {
      console.error(error)
    } finally {
      setProcessandoOperacao(false)
    }
  }

  const cancelar = () => {
    if (route.origem === 'CONFIRMACAO') {
      router.history.push(`/solicitacaoexame/fichasolicitacaoexame/detalhar/${exameSolicitado.id_solicitacao_exame}`)
      return
    }

    if (route.origem === 'ADICAO') {
      router.history.push(`/solicitacaoexame/fichasolicitacaoexame/detalhar/${params.idSolicitacao}`)
      return
    }

    if (route.origem === 'EDICAO') {
      router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${exameSolicitado.id}`)
      return
    }

    setOpen(false)
    resetForm()
  }

  const isExameToxicologico = (tipoExame) => {
    const listaExamesToxicologicos = [
      'TOXICOLOGICO_IN_VIVO',
      'TOXICOLOGICO_POST_MORTEM_DAF',
      'TOXICOLOGICO_POST_MORTEM_PEST',
      'DOSAGEM_ALCOOLICA',
      'TOXICOLOGICO_ALCOOLEMIA_VIVO',
      'TOXICOLOGICO_FARMACOS_DROGAS',
      'TOXICOLOGIA_MATRIZES',
      'TOXICOLOGICO_SOLVENTES_ORGANICOS',
      'TOXICOLOGICO_INVIVO_AGROTOXICO',
    ]
    return listaExamesToxicologicos.includes(tipoExame?.cod)
  }

  const isExameBiologia = (tipoExame) => {
    // prettier-ignore
    const listaExamesBiologia = [
      'PESQUISA_SANGUE_HUMANO',
      'ESPERMATOSOIDE_PSA',
      'MATERIAL_CAPILAR_HUMANO',
      'GRAVIDEZ',
    ]
    return listaExamesBiologia.includes(tipoExame?.cod)
  }

  const verificarErroExameDNA = (form) => {
    let erro = false

    if (!form.objetivoExame) {
      erro = true
    }
    if (!form.listaObjetosExaminados?.length) {
      erro = true
    } else {
      form.listaObjetosExaminados.forEach((objeto) => {
        if (!objeto.tipoMaterialBiologico || !objeto.tipoAmostra) {
          erro = true
        }

        if (form.listaObjetosExaminados.length > 2) {
          if (!objeto.prioridade || !objeto.justificativa) {
            erro = true
          }
        }
      })
    }

    return erro
  }

  const verificarErroExameToxicologico = (form) => {
    let erro = false

    if (!form.tipoCaso || !form.substanciaEnvolvida || !form.suspeitaIntoxicacao || !form.exameToxicologicoEssencial || !form.recebeuSocorro || !form.recebeuMedicamento) {
      erro = true
    }

    if (form.suspeitaIntoxicacao === 'NÃO' && !form.justificativaSolicitacao?.length) {
      erro = true
    }

    if (form.recebeuSocorro === 'SIM' && !form.tempoSocorro?.length) {
      erro = true
    }

    if (form.recebeuMedicamento === 'SIM' && !form.medicamentos?.length) {
      erro = true
    }

    if (form.vitima && form.vitima?.nic && (!form.dataObito || isNaN(form.dataObito))) {
      erro = true
    }

    if (!form.pendenteConfirmacao && (!form.dataColeta || isNaN(form.dataColeta))) {
      erro = true
    }

    return erro
  }

  const verificarErroExameBiologia = (form) => {
    let erro = false
    const { vitima, dataColeta, horaColeta, dataFato, horaFato, concursoPessoas, conjuncaoCarnal, usoPreservativo, realizouHigiene, coletadoEmLocal, usoLuminol, coletadoDiretamente, pendenteConfirmacao, isVitimaDesconhecida } = form
    if (pendenteConfirmacao) return false
    if (!dataColeta || !horaColeta) return true
    if (!isVitimaDesconhecida && !vitima) return true
    switch (form.tipoEx?.cod) {
      case 'ESPERMATOSOIDE_PSA':
        if (!horaFato || !dataFato || !concursoPessoas || conjuncaoCarnal.length === 0 || !usoPreservativo || !realizouHigiene) {
          erro = true
        }
        break
      case 'MATERIAL_CAPILAR_HUMANO':
        if (!coletadoEmLocal || !coletadoDiretamente) {
          erro = true
        }
        break
      case 'PESQUISA_SANGUE_HUMANO':
        if (!coletadoEmLocal || !usoLuminol) {
          erro = true
        }
        break
      case 'GRAVIDEZ':
    }
    return erro
  }

  useEffect(() => {
    let erro = false
    if (!form.tipoEx || !form.setor) {
      erro = true
    }

    if (form.tipoEx?.cod === tiposDeExame.DNA) {
      erro = erro || verificarErroExameDNA(form)
    }

    if (isExameToxicologico(form.tipoEx)) {
      erro = erro || verificarErroExameToxicologico(form)
    }

    if (isExameBiologia(form.tipoEx)) {
      erro = erro || verificarErroExameBiologia(form)
    }

    setFormErro(erro)
  }, [form])

  useEffect(() => {
    // edição de exame durante cadastro de solicitação (exame ainda não presente no banco)
    if (editar && exameSolicitado) {
      let listaObjetosExaminados = []
      if (exameSolicitado.vests) {
        listaObjetosExaminados = listaObjetosExaminados.concat(
          exameSolicitado.vests.map((vestigio) => {
            vestigio.flag = 'VESTIGIO'
            return vestigio
          })
        )
      }
      if (exameSolicitado.cadavs) {
        listaObjetosExaminados = listaObjetosExaminados.concat(
          exameSolicitado.cadavs.map((cadaver) => {
            cadaver.flag = 'CADAVER'
            return cadaver
          })
        )
      }
      if (exameSolicitado.perics) {
        listaObjetosExaminados = listaObjetosExaminados.concat(
          exameSolicitado.perics.map((periciando) => {
            periciando.flag = 'PERICIANDO'
            return periciando
          })
        )
      }
      if (exameSolicitado.locais) {
        listaObjetosExaminados = listaObjetosExaminados.concat(
          exameSolicitado.locais.map((local) => {
            local.flag = 'LOCAL'
            return local
          })
        )
      }
      if (exameSolicitado.veiculos) {
        listaObjetosExaminados = listaObjetosExaminados.concat(
          exameSolicitado.veiculos.map((veiculo) => {
            veiculo.flag = 'VEICULO'
            return veiculo
          })
        )
      }

      setForm((prevState) => ({
        ...exameSolicitado,
        pendenteConfirmacao: route.origem === 'CONFIRMACAO' || route.origem === 'EDICAO' ? false : exameSolicitado.pendenteConfirmacao,
        suspeitaIntoxicacao: exameSolicitado.suspeitaIntoxicacao === true ? 'SIM' : exameSolicitado.suspeitaIntoxicacao === false ? 'NÃO' : 'NÃO INFORMADO',
        exameToxicologicoEssencial: exameSolicitado.exameToxicologicoEssencial === true ? 'SIM' : exameSolicitado.exameToxicologicoEssencial ? 'NÃO' : 'NÃO INFORMADO',
        listaObjetosExaminados,
        vitima: exameSolicitado.vitima || exameSolicitado.vitima_cadaver || null,
        //atosLibidinosos: exameSolicitado.atosLibidinosos?.split(', ') || [],
        conjuncaoCarnal: exameSolicitado.conjuncaoCarnal?.split(', ') || [],
      }))

      setListaObjetosDoCaso(getListaObjetosDoCasoPorExame(exameSolicitado.tipoEx))
    }
  }, [editar, exameSolicitado, getListaObjetosDoCasoPorExame])

  const renderFormFields = () => {
    return (
      <>
        <Grid item lg={6} md={7} sm={12} xs={12}>
          <Autocomplete
            value={form.tipoEx}
            getOptionSelected={(option, value) => option.id === value.id}
            name="tipoEx"
            noOptionsText="Sem informações"
            options={tiposExames || []}
            onChange={(event, newValue) => handleChangeTipoExame(newValue)}
            getOptionLabel={(option) => option.nome?.toUpperCase()}
            renderOption={(option) => option.nome?.toUpperCase()}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="EXAME SOLICITADO"
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder="Selecionar..."
                required
              />
            )}
            required
          />
        </Grid>
        <Grid item lg={6} md={5} sm={12} xs={12}>
          <Autocomplete
            name="setor"
            value={form.setor}
            noOptionsText="Sem informações"
            options={form.tipoEx?.setResps || []}
            getOptionSelected={(option, value) => option.id === value.id}
            onChange={(event, newValue) => handleChange('setor', newValue)}
            disabled={!form.tipoEx}
            required
            getOptionLabel={(option) => `${option.nome?.toUpperCase()} / ${option.divisao?.sigla.toUpperCase()} / ${option.divisao?.regional?.nome.toUpperCase()} / ${option.divisao?.regional?.orgao?.sigla.toUpperCase()}`}
            renderOption={(option) => `${option.nome?.toUpperCase()} / ${option.divisao?.sigla.toUpperCase()} / ${option.divisao?.regional?.nome.toUpperCase()} / ${option.divisao?.regional?.orgao?.sigla.toUpperCase()}`}
            renderInput={(params) => (
              <TextField
                {...params}
                required
                variant="outlined"
                label="SETOR RESPONSÁVEL PELO EXAME"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </Grid>
        {!form.pendenteConfirmacao && !(route.origem === 'REQUISICAO') && (
          <Grid item md={12} sm={12} xs={12}>
            <Autocomplete
              name="listaObjetosSelecionados"
              value={form.listaObjetosExaminados}
              noOptionsText="Sem informações"
              multiple
              getOptionSelected={(option, value) => option.id === value.id}
              options={listaObjetosDoCaso}
              onChange={(event, newValue) => handleChange('listaObjetosExaminados', newValue)}
              disabled={!form.tipoEx}
              required
              getOptionLabel={(option) => {
                if (option.flag === 'VESTIGIO') {
                  const texto = `VESTÍGIO ${option.identificador} - ${option.descricao?.toUpperCase()}`
                  return texto.length > 50 ? texto.slice(0, 50) + '...' : texto
                }
                if (option.flag === 'CADAVER') return `CADÁVER - NIC: ${option.nic}`
                if (option.flag === 'VEICULO') return `VEÍCULO - PLACA: ${option.placa} | IDENTIFICADOR: ${option.identificador}`
                if (option.flag === 'LOCAL') return `LOCAL - ENDEREÇO: ${getLabelEndereco(option)?.toUpperCase()}`

                if (option.flag === 'PERICIANDO')
                  return `PERICIANDO - CPF: ${option.cpf || 'NÃO INFORMADO'} - 
                                  ${option.nome ? `NOME: ${option.nome}` : `ALCUNHA: ${option.alcunha}` || 'NÃO INFORMADO'}`
                return ''
              }}
              renderOption={(option) => {
                if (option.flag === 'VESTIGIO') {
                  const texto = `VESTÍGIO ${option.identificador} - ${option.descricao?.toUpperCase()}`
                  return texto.length > 80 ? texto.slice(0, 80) + '...' : texto
                }
                if (option.flag === 'CADAVER') return `CADÁVER - NIC: ${option.nic}`
                if (option.flag === 'VEICULO') return `VEÍCULO - PLACA: ${option.placa} | IDENTIFICADOR: ${option.identificador}`
                if (option.flag === 'LOCAL') return `LOCAL - ENDEREÇO: ${getLabelEndereco(option)?.toUpperCase()}`

                if (option.flag === 'PERICIANDO')
                  return `PERICIANDO - CPF: ${option.cpf || 'NÃO INFORMADO'} - 
                                  ${option.nome ? `NOME: ${option.nome}` : `ALCUNHA: ${option.alcunha}` || 'NÃO INFORMADO'}`
                return ''
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="OBJETOS EXAMINADOS"
                  variant="outlined"
                  placeholder="selecione..."
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </Grid>
        )}

        {form.tipoEx?.cod === 'DNA' && !form.pendenteConfirmacao && (
          <Grid item xs={12}>
            <SecaoGenerica titulo="QUESTIONÁRIO DE REQUISIÇÃO" spacing={2}>
              <FormDNA pendenteConfirmacao={form.pendenteConfirmacao} listaVitima={listaVitima} listaPericiandos={listaPericiandos} form={form} setFormErro={setFormErro} handleChange={handleChange} />
            </SecaoGenerica>
          </Grid>
        )}

        {isExameToxicologico(form.tipoEx) && (
          <Grid item xs={12}>
            <SecaoGenerica titulo="QUESTIONÁRIO DE REQUISIÇÃO" spacing={2}>
              <FormToxicologia pendenteConfirmacao={form.pendenteConfirmacao} listaVitima={listaVitima} form={form} setFormErro={setFormErro} handleChange={handleChange} idCaso={idCaso} />
            </SecaoGenerica>
          </Grid>
        )}

        {isExameBiologia(form.tipoEx) && !form.pendenteConfirmacao && (
          <Grid item xs={12}>
            <SecaoGenerica titulo="QUESTIONÁRIO DE REQUISIÇÃO" spacing={2}>
              <FormBiologia tipoExame={form.tipoEx} pendenteConfirmacao={form.pendenteConfirmacao} listaVitima={listaVitima} form={form} setFormErro={setFormErro} handleChange={handleChange} idCaso={idCaso} />
            </SecaoGenerica>
          </Grid>
        )}
      </>
    )
  }

  if (aberto !== undefined) {
    return (
      <ModalConfirmacao
        aberto={aberto}
        onClose={cancelar}
        onConfirm={confirmar}
        processando={processandoOperacao}
        disabled={formErro}
        titulo={editar ? 'Editar Exame' : 'Adicionar Exame'}
        maxWidth="lg"
        confirmarColor="primary"
        cancelarColor="error"
      >
        <Grid container spacing={2} style={{ paddingTop: '10px' }}>
          {renderFormFields()}
        </Grid>
      </ModalConfirmacao>
    )
  }

  return (
    <form id="form-adicionar-exame" onSubmit={(e) => e.preventDefault()} style={{ width: '100%' }}>
      <Grid container spacing={3}>
        <Grid item container spacing={2}>
          {renderFormFields()}
        </Grid>
      </Grid>

      <Divider style={{ margin: '32px 0 16px 0' }} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '12px', justifyContent: 'space-between', alignItems: 'center' }}>
            <CustomButton variant="outlined" colorType="primary" startIcon={<ArrowBackIcon />} onClick={() => cancelar()}>
              Cancelar
            </CustomButton>
            <CustomButton variant="contained" colorType="secondary" startIcon={<SaveIcon />} disabled={processandoOperacao || formErro} isLoading={processandoOperacao} onClick={() => confirmar()}>
              {route.origem === 'EDICAO' ? 'Atualizar Exame' : route.origem === 'CONFIRMACAO' ? 'Confirmar Exame' : 'Cadastrar Exame'}
            </CustomButton>
          </div>
        </Grid>
      </Grid>
    </form>
  )
}
